import React, { useState } from "react";
import { track } from "../../util/tracking";

const formLinks = {
  yes:
    "https://forms.office.com/Pages/ResponsePage.aspx?id=P-50kiWUCUGif5-xXBBnXazWWR427oVLtysCdiOfy-JUQllNWlo0UEpLOFhaVUZKOUtWTzJHNVdNRC4u",
  no:
    "https://forms.office.com/Pages/ResponsePage.aspx?id=P-50kiWUCUGif5-xXBBnXazWWR427oVLtysCdiOfy-JUN0dFR0oxMkdHQlZWMUNaUlJCSkIzMURHUC4u",
};

type ButtonClickedState = "yes" | "no" | null;

const Banner = () => {
  const [buttonClicked, setButtonClicked] = useState<ButtonClickedState>(null);
  const handleHelpfulButton = (e: React.MouseEvent<HTMLButtonElement>) => {

      if (e.currentTarget.name === "yes") {
      setButtonClicked("yes");
      track("buttonClick", {
        buttonType: "sch:helpful-yes",
      });
    }
    if (e.currentTarget.name === "no") {
      setButtonClicked("no");
      track("buttonClick", {
        buttonType: "sch:helpful-no",
      });
    }
  };

  return (
    <div className="banner" >
      <span className="banner-text float-left">
        This is a new submission-tracking service.
      </span>
      <span className="float-right">
        {buttonClicked ? (
          <span className="banner-text">
            Thank you, could you{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={formLinks[buttonClicked]}
            >
              tell us more
            </a>
            ?
          </span>
        ) : (
          <>
            Is this helpful?
            <button
              name="yes"
              onClick={handleHelpfulButton}
              className="bttn tertiary"
            >
              Yes
            </button>
            <button
              name="no"
              onClick={handleHelpfulButton}
              className="bttn tertiary"
            >
              No
            </button>
          </>
        )}
      </span>
    </div>
  );
};

export default Banner;
